module.exports = true;



//////////////////
// WEBPACK FOOTER
// ../js/~/core-js/library/modules/_library.js
// module id = 117
// module chunks = 0